import { Component, OnInit, Input } from '@angular/core';
import { Person } from 'src/app/shared/models/person';

@Component({
    selector: 'app-contributor-list',
    templateUrl: './contributor-list.component.html',
    styleUrls: ['./contributor-list.component.scss'],
    standalone: false
})
export class ContributorListComponent implements OnInit {
  @Input() people : Person[];
  
  constructor() {}

  ngOnInit() {
  }

}
